import { AxiosError } from 'axios';
import { RollbarFrame, RollbarItem } from 'src/types';

export type AxiosResponseToRollbarType = {
  data: {
    response: unknown;
    code: number;
    data: unknown;
  };
};

const isAxiosResponseError = (error: AxiosError | unknown): error is AxiosError => {
  return (error as AxiosError)?.response !== undefined;
};

export const parseErrorToRollbar = (error: AxiosError | unknown): AxiosResponseToRollbarType | { data: unknown } => {
  if (isAxiosResponseError(error)) {
    return {
      data: {
        response: error?.response,
        code: error?.code,
        data: error?.config?.data,
      },
    };
  }

  return { data: error };
};

export const isFromExtension = (item: RollbarItem): boolean => {
  const frames: RollbarFrame[] = item?.body?.trace_chain?.flatMap((trace) => trace.frames) || [];
  const messages: string[] = item?.body?.trace_chain?.flatMap((trace) => trace.exception.message) || [];

  const isExtensionScript = frames.some((frame) => {
    const filename = frame?.filename.toLowerCase() || '';
    return (
      filename.includes('chrome-extension://') ||
      filename.includes('moz-extension://') ||
      filename.includes('safari-extension://') ||
      filename.includes('extensions') ||
      filename.includes('script.hotjar') ||
      filename === 'anonymous'
    );
  });

  const isLikelyExtension = messages.some((message) => {
    return (
      message.includes('chrome-extension') ||
      message.includes('moz-extension') ||
      message.includes('safari-extension') ||
      message === 'Script error.'
    );
  });

  return isExtensionScript || isLikelyExtension;
};
